/* src/app/on-property/trailer-list/trailer-list.component.scss */
:host {
  height: 100%;
  width: 100%;
  display: flex;
}
:host .trailer-items {
  overflow-x: hidden !important;
  height: 100%;
  width: 100%;
}
:host .loading {
  min-height: 300px;
  max-width: 900px;
  width: 100%;
  padding: 0 16px;
}
:host ::ng-deep .scrollable-content {
  padding-top: 1px;
}
:host ::ng-deep .selected .trailer {
  border: 3px solid var(--Colors-UPS-Blue, #426DA9);
  border-radius: 4px;
  height: 60px;
  width: 348px;
  margin: -2px 6px;
}
:host ::ng-deep .selected.first .trailer {
  margin-top: 2px;
}
/*# sourceMappingURL=trailer-list.component.css.map */
